import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import LoginHandler from "../../Apihander/login/loginHandler";
import { successToast, errorToast } from '../../utils/notificationUtils'
import '../../css/login.css'
import { useForm } from "react-hook-form";
import Lottie from "react-lottie";
import loginsuccessfully from "../../animations/loginsuccessfully.json"
import SidebarContext from "../../contexts/MyContext";
import { GoogleLogin, useGoogleLogin } from "@react-oauth/google";
import SignUpHandler from "../../Apihander/signup/signupHandler";
import { fetchUserInfo } from "../../utils/googleAuthUtils";
import AppleLogin from "react-apple-login";
import Modal from "../../components/Modal/Modal";
import SettingHandler from "../../Apihander/setting/settingHandler";
import { detectBrowser } from "../../utils/detectbrowser";
import { jwtDecode } from "jwt-decode";
import { useMakePayment } from "../../hooks/useMakePayment";
const { detect } = require('detect-browser');



const LoginModal = ({ closeModal, openModal, handleResendOtp, closePremiumModal }) => {
    const detectbrowser = detect();
    // Brave detection logic
    let detectDeviceName = detectbrowser?.name || "unknown";

    // Check for Brave specifics
    if (detectbrowser?.name === 'chrome') {
        // Additional checks for Brave
        if (navigator.brave || window.navigator.userAgent.includes('Brave')) {
            detectDeviceName = 'brave';
        }
    }


    const { register, handleSubmit, formState: { errors }, watch, reset } = useForm();
    const { storeUser, setOpenForgotPasswordModal, setOpenOtpModal, setStoreOtpUser, isPremium, setIsLoginCancel, } = useContext(SidebarContext);
    const { handleMakePaymentOfPremium } = useMakePayment();

    const [loading, setLoading] = useState(false)


    const navigate = useNavigate();
    const [load, setLoad] = useState(false);
    const [success, setSuccess] = useState(false);

    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: loginsuccessfully,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };

    const handleCreateAccountClick = () => {
        if (isPremium) {
            closePremiumModal()
        } else {
            closeModal();
        }
        openModal();
    };




    const onsubmit = async (payload) => {
        try {



            const newPayload = {
                ...payload,
                deviceType: detectbrowser.type,
                deviceName: detectDeviceName,
                recipte_id: ""
            }

            setLoad(true);
            // Call the login function from your authentication service
            const data = await LoginHandler.doHandelLogin(newPayload);

            if (data?.data?.token) {
                localStorage.setItem('token', data?.data?.token);
            }

            if (data?.data?.user?.verified && data?.statusCode === 200) {
                // If login is successful, proceed
                setLoad(false);
                setSuccess(true)
                closeModal();
                const userWithSubscription = {
                    ...data?.data?.user,
                    isSubscriptionActive: data?.data?.isSubscriptionActive,
                    hasSubscribe: data?.data?.hasSubscribe
                }
                storeUser(JSON.stringify(userWithSubscription));
                // navigate("/")

                if (isPremium && !data?.data?.isSubscriptionActive) {
                    await handleMakePaymentOfPremium()
                } else {
                    // navigate('/')
                    navigate("/dashboard")
                }

            }
            if (!data?.data?.user?.verified && data?.statusCode === 200) {
                const resendOtpResponse = await SignUpHandler.doHandlerResendOtpSubmit()
                setOpenOtpModal(true)
                closeModal();
                localStorage.setItem('RegisterEmail', data?.data?.user?.email)
                setStoreOtpUser(JSON.stringify(data?.data?.user))
            }
            else if (data?.statusCode != 200) {
                const errorMessage =
                    data?.response?.data?.message || data?.message || "An error occurred";
                console.log(errorMessage);
                setLoad(false);
                errorToast(errorMessage);
            }


        } catch (error) {
            console.error("Login failed:", error);
            setLoad(false);
            const errorMessage =
                error?.response?.data?.message || error.message || "An error occurred";
            errorToast(errorMessage);
        }
    };


    const login = useGoogleLogin({

        onSuccess: async (response) => {

            try {
                // Check if access_token is available in the response
                if (!response || !response.access_token) {
                    throw new Error('No access token found in response');
                }

                // Extract the access_token from the response
                const token = response.access_token;

                // Fetch user information using the access token
                const userInfo = await fetchUserInfo(token);



                const payload = {
                    name: userInfo?.name,
                    email: userInfo?.email,
                    google_Id: userInfo?.sub,
                    socialType: "GOOGLE",
                    deviceType: detectbrowser.type,
                    deviceName: detectDeviceName,
                    recipte_id: ""

                };

                const data = await SignUpHandler.doHandlerGoogleLogin(payload);
                if (data?.statusCode === 200) {
                    const userWithSubscription = {
                        ...data?.data?.user,
                        isSubscriptionActive: data?.data?.isSubscriptionActive,
                        hasSubscribe: data?.data?.hasSubscribe
                    }
                    storeUser(JSON.stringify(userWithSubscription));
                    setIsLoginCancel(false)
                    closeModal();
                    if (isPremium && !data?.data?.isSubscriptionActive) {
                        await handleMakePaymentOfPremium()

                    } else {
                        // navigate('/')
                        navigate("/dashboard")

                    }
                }

            } catch (error) {
                console.error('Error during login:', error);
            }
        },
        onError: (error) => {
            console.log('Google login failed:', error);
        },
        usePopup: true,
    });




    const handleAppleLoginSuccess = async (response) => {
        // console.log('Apple login success:', response);
        try {
            const decodedToken = jwtDecode(response.id_token);
            const userIdentifier = decodedToken.sub;
            const payload = {
                // name: response.name,
                // email: response.email,
                // apple_id: "",
                identityToken: response.id_token,
                recipte_id: "",
                socialType: 'APPLE',
                deviceType: detectbrowser.type,
                deviceName: detectDeviceName,
            };

            // console.log('payload at time of apple login', payload);
            const data = await SignUpHandler.doHandlerAppleLogin(payload)

            // storeUser(JSON.stringify(data?.user));
            if (data?.statusCode === 200) {
                const userWithSubscription = {
                    ...data?.data?.user,
                    isSubscriptionActive: data?.data?.isSubscriptionActive,
                    hasSubscribe: data?.data?.hasSubscribe
                }
                storeUser(JSON.stringify(userWithSubscription));
                // console.log('Apple login successful:', data);
                closeModal();

                if (isPremium && !data?.data?.isSubscriptionActive) {
                    await handleMakePaymentOfPremium()

                } else {
                    // navigate('/')
                    navigate("/dashboard")

                }
            }

        } catch (error) {
            console.log('Error:', error);
        }

    };

    const handleAppleLoginError = (error) => {
        console.error('Apple login error:', error);
    };


    const openCloseModal = () => {
        setOpenForgotPasswordModal(true)
        closeModal()
    }




    return (
        <>
            <section className="">
                <div className="container-fluid h-custom">
                    <div
                        className="modal d-block"
                        style={{ background: "#0000009e" }}
                        tabIndex="-1"
                    >
                        <div
                            className="modal-dialog modal-dialog-centered custom-modal-login"
                        >
                            <div className="modal-content rounded-lg-md-sm" style={{ borderRadius: '20px' }}>
                                <div className="modal-body">
                                    <div className="row signup-main-content">
                                        <div className="col-lg-5 col-md-5 col-sm-12">
                                            <form
                                                className="custom-modal-form"
                                                action=""
                                                method=""
                                                onSubmit={handleSubmit(onsubmit)}
                                                noValidate

                                            >
                                                <div className="main-text">
                                                    <p className="text-md main-heading-login">
                                                        Welcome Back
                                                    </p>
                                                    <p
                                                        className="sub-heading-login">
                                                        Login to your account and start Voice Recording and
                                                        Editing
                                                    </p>
                                                </div>
                                                <div className="form-group custom-input">
                                                    <input
                                                        type="email"
                                                        className={`form-control custom-input-field ${errors.email ? 'error' : ''}`}
                                                        id="email"
                                                        aria-describedby="emailHelp"
                                                        placeholder="Enter your email"
                                                        name="email"
                                                        {...register("email", {
                                                            required: 'Email address is required',
                                                            pattern: {
                                                                value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                                                                message: 'Enter a valid email address'
                                                            }
                                                        })}

                                                    />
                                                    {errors.email && <span className="error-message">{errors.email.message}</span>}
                                                </div>
                                                <div className="form-group custom-input">
                                                    <input
                                                        type="password"
                                                        className={`form-control custom-input-field ${errors.password ? 'error' : ''}`}
                                                        id="exampleInputPassword1"
                                                        placeholder="Enter password"
                                                        name="password"
                                                        {...register("password", {
                                                            required: 'Enter your password',
                                                            // pattern: {
                                                            //     value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/,
                                                            //     message: 'Password must contain at least 8 characters, one uppercase, one lowercase, and one number'
                                                            // },
                                                            minLength: {
                                                                value: 6,
                                                                message: 'Password should be at least 6 characters'
                                                            },
                                                            maxLength: { value: 12, message: "**Password cannot exceed more than 12 characters" }

                                                        })}
                                                    />

                                                    {errors.password && <span className="error-message">{errors.password.message}</span>}
                                                </div>
                                                <p
                                                    // className="text-md navigation-main-text"
                                                    className="navigation-text "

                                                    style={{ display: 'flex', flexDirection: 'row-reverse', marginRight: '12px' }}
                                                >

                                                    <a
                                                        onClick={() => openCloseModal()}
                                                    >
                                                        Lost Your Password?
                                                    </a>
                                                </p>
                                                <div className="form-group custom-input">
                                                    {success ? (
                                                        <>
                                                            <span style={{ color: 'green', fontSize: '12px' }}> You have Login Successfully</span>
                                                            <Lottie options={defaultOptions} height={100} width={100} />
                                                        </>
                                                    ) : (<button
                                                        type="submit"
                                                        className="btn-submit"
                                                        // disabled={!email || !password}
                                                        // style={{

                                                        //     cursor:
                                                        //         !email || !password ? "not-allowed" : "pointer",
                                                        // }}
                                                        disabled={load}
                                                        style={{ cursor: load ? 'not-allowed' : 'pointer' }}

                                                    >

                                                        {load ? (
                                                            <>
                                                                <span style={{ marginRight: '10px' }}>Loging in</span>

                                                                <div
                                                                    className="spinner-border spinner-login"
                                                                    role="status"
                                                                >
                                                                    <span className="visually-hidden">Loading...</span>
                                                                </div>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <span>
                                                                    Login
                                                                </span>
                                                            </>
                                                        )
                                                        }
                                                    </button>)}

                                                    {/* <button
                                                        type="submit"
                                                        className="btn-submit"
                                                        // disabled={!email || !password}
                                                        // style={{

                                                        //     cursor:
                                                        //         !email || !password ? "not-allowed" : "pointer",
                                                        // }}
                                                        disabled={load}
                                                        style={{ cursor: load ? 'not-allowed' : 'pointer' }}

                                                    >

                                                        {load ? (
                                                            <>
                                                                <div
                                                                    className="spinner-border spinner-login"
                                                                    role="status"
                                                                >
                                                                    <span className="visually-hidden">Loading...</span>
                                                                </div>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <span>
                                                                    Login
                                                                </span>
                                                            </>
                                                        )
                                                        }
                                                    </button> */}

                                                </div>
                                                <div
                                                    className="form-group m-2 custom-vector-line"
                                                >
                                                    <img
                                                        src="/img/login/VectorLeft.png"
                                                        alt="left vector"
                                                        className="left-vector"

                                                    />
                                                    <p className="vector-font">OR</p>
                                                    <img
                                                        src="/img/login/VectorRight.png"
                                                        alt="Right vector"
                                                        className="right-vector"

                                                    />
                                                </div>
                                                {/* <div className="form-group m-2 social-group">
                                                    <button
                                                        type="button"
                                                        className="social-btn"
                                                    >
                                                        <img
                                                            src="img/login/apple_icon.png"
                                                            alt="Apple"
                                                            className="social-img"
                                                            style={{ marginRight: '5px' }}

                                                        />
                                                        Continue with Apple
                                                    </button>
                                                </div> */}
                                                <div className="">
                                                    <AppleLogin
                                                        clientId="com.voicerecorder.memo.client"
                                                        // clientId="com.aaci.web.client"
                                                        redirectURI='https://voicememo.co/'
                                                        // redirectURI="https://1302-1-voicerec-web.vercel.app/"
                                                        scope={'name email'}
                                                        responseMode="query"
                                                        usePopup={true}
                                                        // onSuccess={handleAppleLoginSuccess}
                                                        // onError={handleAppleLoginError}
                                                        render={(props) => (
                                                            <div className="form-group m-2 social-group" onClick={props.onClick}>
                                                                <button
                                                                    type="button"
                                                                    className="social-btn"
                                                                    disabled={props.disabled} // Disable the button if necessary
                                                                    style={{ fontWeight: "600" }}
                                                                >
                                                                    <img
                                                                        src="/img/login/apple_icon.png"
                                                                        alt="Apple"
                                                                        className="social-img"
                                                                        style={{ marginRight: '5px' }}
                                                                    />
                                                                    Continue with Apple
                                                                </button>
                                                            </div>
                                                        )}
                                                        callback={(data) => {
                                                            // console.log(data, 'callback DATA APPLE LOGIN ON LOGIN')
                                                            if (data?.authorization) {
                                                                // const decodeGoogleCred = await jwtDecode(data?.authorization?.id_token);
                                                                handleAppleLoginSuccess(
                                                                    data?.authorization
                                                                );
                                                            }
                                                        }}
                                                    />
                                                </div>
                                                <div className="form-group m-2 social-group"
                                                    onClick={() => login()}
                                                >
                                                    <button
                                                        type="button"
                                                        className="social-btn"
                                                        style={{ fontWeight: "600" }}

                                                    >
                                                        <img
                                                            src="/img/login/google_icon.png"
                                                            alt="Apple"
                                                            className="social-img"
                                                        />
                                                        Continue with Google
                                                    </button>
                                                </div>

                                                {/* <div
                                                    className="form-group m-2 social-group"
                                                >
                                                    <div
                                                    type="button"
                                                    className="social-btn"
                                                    >
                                                    
                                                        <GoogleLogin style={{
                                                            border: "none !important",
                                                            backgroundColor: "#F1F5F9 !important",
                                                            color: "#000000 !important"
                                                        }} onSuccess={responseMessage} onError={errorMessage} />
                                                    </div>
                                                </div> */}
                                                <div className="form-group m-2 footer-text" >
                                                    <p
                                                        className="text-md terms-privacy-text"
                                                    >
                                                        By proceeding, you agree to our Terms and Privacy
                                                        Policy.
                                                    </p>
                                                    <p
                                                        className="text-md navigation-main-text"
                                                    >
                                                        Don't have an acoount?{" "}
                                                        <a
                                                            className="navigation-text"
                                                            onClick={() => handleCreateAccountClick()}
                                                        >
                                                            Create account
                                                        </a>
                                                    </p>

                                                </div>
                                            </form>
                                        </div>
                                        <div className="col-lg-7 col-md-7 col-sm-12 position-relative">
                                            <div className="d-flex align-item-end justify-content-end">
                                                <button
                                                    type="button"
                                                    className="close-btn"
                                                    onClick={() => {
                                                        if (!load) {
                                                            closeModal();
                                                        }
                                                    }}
                                                    data-bs-dismiss="modal"
                                                    aria-label="Close"
                                                    style={{
                                                        background: load ? "#d1d5db" : "#F1F5F9",
                                                        color: load ? "#9ca3af" : "#94A3B8",
                                                        cursor: load ? "not-allowed" : "pointer"
                                                    }}
                                                >
                                                    <span aria-hidden="true">&times;</span>

                                                </button>
                                            </div>
                                            <div className="d-none d-sm-flex img-login-main">
                                                <img
                                                    src="/img/login/signup.png"
                                                    alt="signup"
                                                    className="img-login"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    );
};
export default LoginModal;
